import { createContext } from 'react'
import { defaultOptimizelyContext, OptimizelyContextType } from 'models/optimizely'

export const OptimizelyContext = createContext<OptimizelyContextType>(defaultOptimizelyContext)
